module.exports = __webpack_public_path__ + "static/media/nationalParks.8ac0faef.zip";